<template>
  <div>
    <div class="tab-list">
      <Row :gutter="8" style="margin: 0rem 0 0 0; width: 100%" v-if="menus && menus.length > 0">
        <Menu mode="horizontal" :active-name="menu_name" @on-select="selectMenu" style="width: 100%">
          <div v-for="(v, k) in menus"  style="display:inline-block;" :key="k">
            <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick" v-show="v.show === true ? false : true">
            <Badge :overflow-count="10000000" v-if="v.badge && v.badge.count" :count="v.badge.count" :offset="[18, -3]">
              {{ v.label }}
            </Badge>
            <span v-if="!(v.badge && v.badge.count)">
              {{ v.label }}
            </span>
            </MenuItem>
          </div>
        </Menu>
      </Row>
    </div>
    <div class="work_order" style="padding-bottom: 2.5rem">
      <div class="work_order_header" style="text-align: center; margin: 1.25rem 0">
        <h2>工单</h2>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="时间段" align="center" min-width="6.25rem" header-cell-class-name="header_taber">
          <template slot-scope="scope">
            <span>{{ scope.row.state == 2 ? "接单时间" : "维修时间"
              }}<br />（小时:分钟）</span>
          </template>
        </el-table-column>
        <el-table-column label="时长" align="center" min-width="8.75rem">
          <template slot-scope="scope">
            <TimePicker format="HH:mm" v-model="scope.row.limitedDuration" :editable="false" type="time"
              style="width: 5rem" />
          </template>
        </el-table-column>
        <el-table-column label="积分" align="center" min-width="6.25rem">
          <template slot-scope="scope">
            <InputNumber :min="0" :precision="0" v-model="scope.row.addFraction" style="width: 3.75rem" />
          </template>
        </el-table-column>
        <el-table-column label="一级超时" align="center" min-width="15rem">
          <template slot-scope="scope">
            <div class="one-overtime">
              超时
              <TimePicker format="HH:mm" v-model="scope.row.fristTime" :editable="false"
                style="width: 5rem; margin-right: .625rem" />
              扣除
              <InputNumber :min="0" :precision="0" v-model="scope.row.fristFractionSub" style="width: 3.75rem" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="二级超时" align="center" min-width="15rem">
          <template slot-scope="scope">
            超时
            <TimePicker format="HH:mm" v-model="scope.row.secondTime" :editable="false"
              style="width: 5rem; margin-right: .625rem" />
            扣除
            <InputNumber :min="0" :precision="0" v-model="scope.row.secondFractionSub" style="width: 3.75rem" />
          </template>
        </el-table-column>
        <el-table-column label="三级超时" align="center" min-width="15rem">
          <template slot-scope="scope">
            超时
            <TimePicker format="HH:mm" v-model="scope.row.thirdTime" :editable="false"
              style="width: 5rem; margin-right: .625rem" />
            扣除
            <InputNumber :min="0" :precision="0" v-model="scope.row.thirdFractionSub" style="width: 3.75rem" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="consumable" style="padding-bottom: 2.5rem">
      <div class="consumable_header" style="text-align: center; margin: 1.25rem 0">
        <h2>耗材派送</h2>
      </div>
      <el-table :data="tableData2" style="width: 100%">
        <el-table-column label="时间段" align="center" min-width="6.25rem" header-cell-class-name="header_taber">
          <template slot-scope="scope">
            <span>{{ scope.row.state == 2 ? "接单时间" : "完成时间"
              }}<br />（小时:分钟）</span>
          </template>
        </el-table-column>
        <el-table-column label="时长" align="center" min-width="8.75rem">
          <template slot-scope="scope">
            <TimePicker format="HH:mm" v-model="scope.row.limitedDuration" :editable="false" style="width: 5rem" />
          </template>
        </el-table-column>
        <el-table-column label="积分" align="center" min-width="6.25rem">
          <template slot-scope="scope">
            <InputNumber :min="0" :precision="0" v-model="scope.row.addFraction" style="width: 3.75rem" />
          </template>
        </el-table-column>
        <el-table-column label="一级超时" align="center" min-width="15rem">
          <template slot-scope="scope">
            <div class="one-overtime">
              超时
              <TimePicker format="HH:mm" v-model="scope.row.fristTime" :editable="false"
                style="width: 5rem; margin-right: .625rem" />
              扣除
              <InputNumber :min="0" :precision="0" v-model="scope.row.fristFractionSub" style="width: 3.75rem" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="二级超时" align="center" min-width="15rem">
          <template slot-scope="scope">
            超时
            <TimePicker format="HH:mm" v-model="scope.row.secondTime" :editable="false"
              style="width: 5rem; margin-right: .625rem" />
            扣除
            <InputNumber :min="0" :precision="0" v-model="scope.row.secondFractionSub" style="width: 3.75rem" />
          </template>
        </el-table-column>
        <el-table-column label="三级超时" align="center" min-width="15rem">
          <template slot-scope="scope">
            超时
            <TimePicker format="HH:mm" v-model="scope.row.thirdTime" :editable="false"
              style="width: 5rem; margin-right: .625rem" />
            扣除
            <InputNumber :min="0" :precision="0" v-model="scope.row.thirdFractionSub" style="width: 3.75rem" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="consumable" style="padding-bottom: 2.5rem">
      <div class="consumable_header" style="text-align: center; margin: 1.25rem 0">
        <h2>盘点/巡检</h2>
      </div>
      <el-table :data="tableData3" style="width: 100%">
        <el-table-column label="盘点次数" align="center" min-width="6.25rem">
          <template slot-scope="scope">
            <div>
              <InputNumber :min="0" :precision="0" v-model="scope.row.thirdFractionSub" style="width: 3.75rem" />
            </div>
          </template>
        </el-table-column>

        <el-table-column label="巡检次数" align="center" min-width="6.25rem">
          <template slot-scope="scope">
            <!-- <TimePicker format="HH:mm" v-model="scope.row.limitedDuration" :editable="false" style="width: 5rem" /> -->
            <div>
              <InputNumber :min="0" :precision="0" v-model="scope.row.thirdFractionSub1" style="width: 3.75rem" />

            </div>
          </template>
        </el-table-column>
        <el-table-column label="盘点积分" align="center" min-width="6.25rem">
          <template slot-scope="scope">
            <InputNumber :min="0" :precision="0" v-model="scope.row.addFraction" style="width: 3.75rem" />
          </template>
        </el-table-column>
        <el-table-column label="巡检积分" align="center" min-width="6.25rem">
          <template slot-scope="scope">
            <InputNumber :min="0" :precision="0" v-model="scope.row.addFraction1" style="width: 3.75rem" />
          </template>
        </el-table-column>
        <el-table-column label="每日开始时间" align="center" min-width="7.5rem">
          <template slot-scope="scope">
            <TimePicker format="HH:mm" v-model="scope.row.fristTime" :steps="[1, 30]" :editable="false"
              style="width: 80px;" />
          </template>
        </el-table-column>
        <el-table-column label="每日结束时间" align="center" min-width="7.5rem">
          <template slot-scope="scope">
            <TimePicker format="HH:mm" v-model="scope.row.secondTime" :steps="[1, 30]" :editable="false"
              style="width: 80px;" />
          </template>
        </el-table-column>
        <el-table-column label="盘点未完成（每次/分）" align="center" min-width="11.25rem">
          <template slot-scope="scope">
            <InputNumber :min="0" :precision="0" v-model="scope.row.fristFractionSub" style="width: 3.75rem" />
          </template>
        </el-table-column>
        <el-table-column label="巡检未完成（每次/分）" align="center" min-width="11.25rem">
          <template slot-scope="scope">
            <InputNumber :min="0" :precision="0" v-model="scope.row.fristFractionSub1" style="width: 3.75rem" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer_btn" style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 2.5rem 0;
      ">
      <div style="padding-left: 1.25rem">
        <span style="margin-right: 3.75rem; font-size: 1rem">基础积分：</span>
        <InputNumber :min="0" :precision="0" v-model="foundationFraction" style="width: 3.75rem" />
      </div>
      <div class="btn_box">
        <Button v-if="customerId == 0" size="large" type="info" style="width: 9.375rem; margin-right: .625rem"
          @click="onPush()">推送</Button>
        <Button size="large" type="info" style="width: 9.375rem" @click="onSubmit()">保存</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { Select } from "view-design";
let customerId = window.localStorage.getItem("customerId");

export default {
  data() {
    return {
      menus: [
        {
          label: "绩效人员",
          name: "performance_list",
          auth: "",
        }, {
          label: "绩效设置",
          name: "performance_manage",
          auth: "",
        },
      ],
      foundationFraction: 0,
      tableData: [
        {
          workType: 1,
          state: 2,
          limitedDuration: "00:00",
          addFraction: 0,
          fristTime: "00:00",
          fristFractionSub: 0,
          secondTime: "00:00",
          secondFractionSub: 0,
          thirdTime: "00:00",
          thirdFractionSub: 0,
        },
        {
          workType: 1,
          state: 3,
          limitedDuration: "00:00",
          addFraction: 0,
          fristTime: "00:00",
          fristFractionSub: 0,
          secondTime: "00:00",
          secondFractionSub: 0,
          thirdTime: "00:00",
          thirdFractionSub: 0,
        },
      ],
      tableData2: [
        {
          workType: 2,
          state: 2,
          limitedDuration: "00:00",
          addFraction: 0,
          fristTime: "00:00",
          fristFractionSub: 0,
          secondTime: "00:00",
          secondFractionSub: 0,
          thirdTime: "00:00",
          thirdFractionSub: 0,
        },
        {
          workType: 2,
          state: 3,
          limitedDuration: "00:00",
          addFraction: 0,
          fristTime: "00:00",
          fristFractionSub: 0,
          secondTime: "00:00",
          secondFractionSub: 0,
          thirdTime: "00:00",
          thirdFractionSub: 0,
        },
      ],
      tableData3: [
        {
          addFraction: 1,
          addFraction1: 1,
          fristTime: "08:00",
          fristFractionSub: 1,
          fristFractionSub1: 1,
          secondTime: "20:00",
          thirdFractionSub: 10,
          thirdFractionSub1: 10,
        },
      ],
      tableData4: [
        {
          workType: 3,
          addFraction: 1,
          fristTime: "08:00",
          fristFractionSub: 1,
          secondTime: "20:00",
          thirdFractionSub: 10,
        },
        {
          workType: 4,
          addFraction: 1,
          fristTime: "08:00",
          fristFractionSub: 1,
          secondTime: "20:00",
          thirdFractionSub: 10,
        },
      ],
      menu_name: "",
      hospitalId: [],
      customerId: "",
    };
  },
  created() {
    this.customerId = localStorage.getItem("customerId");
    this.load();
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
  },
  methods: {
    async load() {
      let d = {};
      let res = await $utils.api.load("/admin/system/scoringRules/list", d, "get");
      if (res.code == 200 && res.data.length > 0) {
        let arr = res.data;
        arr.forEach(item => {
          if (item.workType == 1) {
            this.tableData = [];
          } else if (item.workType == 2) {
            this.tableData2 = [];
          } else if (item.workType == 3 || item.workType == 4) {
            this.tableData4 = []
          }
        })
        arr.forEach((item) => {
          this.foundationFraction = item.foundationFraction;
          if (item.workType == 1) {
            this.tableData.push(item);
            this.tableData = this.tableData.sort((a, b) => {
              return a.state - b.state;
            });
          } else if (item.workType == 2) {
            this.tableData2.push(item);
            this.tableData2 = this.tableData2.sort((a, b) => {
              return a.state - b.state;
            });
          } else if (item.workType == 3 || item.workType == 4) {

            this.tableData4.push(item)
            this.tableData4 = this.tableData4.sort((a, b) => {
              return a.workType - b.workType
            })
            console.log(this.tableData3[0].fristTime);
            this.tableData3[0].fristTime = item.fristTime
            this.tableData3[0].secondTime = item.secondTime
            if (item.workType == 3) {
              this.tableData3[0].addFraction = item.addFraction
              this.tableData3[0].fristFractionSub = item.fristFractionSub
              this.tableData3[0].thirdFractionSub = item.thirdFractionSub
            } else if (item.workType == 4) {
              this.tableData3[0].addFraction1 = item.addFraction
              this.tableData3[0].fristFractionSub1 = item.fristFractionSub
              this.tableData3[0].thirdFractionSub1 = item.thirdFractionSub
            }
          }
        });
      }
    },
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    async onSubmit() {
      this.tableData4.forEach(item => {
        item.fristTime = this.tableData3[0].fristTime
        item.secondTime = this.tableData3[0].secondTime
        if (item.workType == 3) {
          item.addFraction = this.tableData3[0].addFraction
          item.fristFractionSub = this.tableData3[0].fristFractionSub
          item.thirdFractionSub = this.tableData3[0].thirdFractionSub
        } else if (item.workType == 4) {
          item.addFraction = this.tableData3[0].addFraction1
          item.fristFractionSub = this.tableData3[0].fristFractionSub1
          item.thirdFractionSub = this.tableData3[0].thirdFractionSub1
        }
      })
      let d = this.tableData.concat(this.tableData2);
      d = d.concat(this.tableData4)
      d.map((item) => {
        return (item.foundationFraction = this.foundationFraction);
      });
      console.log(d);
      let res = await $utils.api.load("/admin/system/scoringRules/add", d, "post");
      if (res.code == 200) {
        $utils.toast.success("保存成功");
        this.load();
      }
    },
    onPush() {
      let that = this;
      $utils.api.load("/admin/system/customer/listByAdmin", {}, "get").then((res) => {
        let resList = res.rows;
        this.$Modal.success({
          closable: true,
          title: "推送",
          width: "50rem",
          okText: "取消",
          showOk: false,
          render: (h) => {
            return (
              <div>
                <div style="display:flex;align-items:center;width:100%;padding-top:3.125rem;">
                  <div style="width:6.25rem">医院选择：</div>
                  <Select v-model={that.hospitalId} multiple={true}>
                    {resList.map((item) => {
                      return (
                        <Option
                          label={item.customerName}
                          value={item.id}
                          key={item.id}
                        ></Option>
                      );
                    })}
                  </Select>
                </div>
                <div style="margin-top:6.25rem;width:100%; display:flex;justify-content:right;">
                  <Button
                    size="large"
                    type="info"
                    style="width: 9.375rem;"
                    onClick={() => {
                      that.onPushOk();
                    }}
                  >
                    确定
                  </Button>
                </div>
              </div>
            );
          },
        });
      });
    },
    async onPushOk() {
      let hospitalIds = this.hospitalId.join(",");
      let res = await $utils.api.load(
        `/admin/system/scoringRules/push/${hospitalIds}`,
        {},
        "get"
      );
      if (res.code == 200) {
        this.$Modal.remove()
        $utils.toast.success(res.msg);
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table td.el-table__cell {
  border-bottom: none;
}

/deep/ .el-table th.el-table__cell.is-leaf {
  border-bottom: none;
}

/deep/ .el-table::before {
  background-color: transparent;
}

/deep/ .el-table th.el-table__cell {
  background-color: transparent;
}

/deep/ .el-table thead {
  background-color: #f8f8f9;
  color: #515a6e;
}

/deep/ .el-table tr {
  background-color: transparent;
}
</style>
